import React from 'react';

import featuredLg from '../../images/Home/featuredLg.svg';
import featuredSm from '../../images/Home/featuredSm.svg';
import { lazyLoading } from '../../utils/lazyLoading';
import { ScrollUpButton } from '../Buttons/ScrollUpButton';
import { ISiteSettings } from '../common/Layout';
import { GatsbyLink } from '../Links/GatsbyLink';
import SocialLinks from '../SocialLinks/SocialLinks';

import FooterTags from './FooterTags';

import style from './Footer.scss';

import cn from 'classnames';
import { graphql, StaticQuery } from 'gatsby';
import { Link } from 'gatsby';

export interface IFooterProps {
  className?: string;
  site: ISiteSettings;
  data: {
    allGhostTag: {
      edges: {
        node: {
          name: string;
          slug: string;
        };
      }[];
    };
  };
}

function Footer({ className, site, data }: IFooterProps) {
  const tags = data.allGhostTag.edges;

  React.useEffect(() => {
    lazyLoading();
  }, []);

  return (
    <footer className={cn(className, style.footer)}>
      <ScrollUpButton className={style.scrollUpButton} />
      <div className="container">
        <FooterTags tags={tags} />
        <div className={style.featured}>
          <div className={style.featuredImageWrapper}>
            <img
              src={featuredLg}
              className="d-none d-md-block"
              loading="lazy"
              alt="As featured in CNBC Forbes Business Insider ABC and Market Watch"
              height="56px"
            />
            <img
              src={featuredSm}
              className="d-md-none"
              loading="lazy"
              alt="As featured in CNBC Forbes Business Insider ABC and Market Watch"
              height="56px"
            />
          </div>
        </div>
        <div className={style.footerMiddle}>
          <div className="row">
            <div className="col-12 col-sm-6 col-lg">
              <Link to="/popular/">Popular</Link>
              <Link to="/media-rap-sheet/">Media Rap Sheet</Link>
            </div>
            <div className="col-12 col-sm-6 col-lg">
              <Link to="/about/">About</Link>
              <Link to="/contact/">Contact</Link>
            </div>
            <div className="col-12 col-sm-6 col-lg">
              <Link to="/write-partner/">Write / Partner</Link>
              <Link to="/subscribe/">Subscribe</Link>
              <Link className="d-none d-sm-block d-lg-none" to="/archives/">
                Post Archives
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-lg">
              <Link to="/sponsored-posts/">Sponsored Posts</Link>
              <Link to="/authors/">Authors</Link>
              <Link className="d-none d-sm-block d-lg-none" to="/disclosure/">
                Disclosure
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-lg d-sm-none d-lg-block">
              <Link to="/archives/">Post Archives</Link>
              <Link to="/disclosure/">Disclosure</Link>
            </div>
          </div>
        </div>
        <SocialLinks className={style.socialLinks} />
        <div className={style.footerBottomSection}>
          <p>
            This page may include affiliate links. We may get paid when you click on a link and buy
            a product, at no extra cost to you. <br />
            <GatsbyLink to="/disclosure/">Click here here to learn more.</GatsbyLink>
            <br />
            <br />
          </p>
          <p>
            &copy; 2018—{new Date().getFullYear()} {site.title} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

const FooterQuery = (props: any) => {
  const renderFooter = (data: any) => <Footer data={data} {...props} />;
  return (
    <StaticQuery
      query={graphql`
        query {
          allGhostTag(sort: { fields: postCount, order: DESC }) {
            edges {
              node {
                name
                slug
              }
            }
          }
        }
      `}
      render={renderFooter}
    />
  );
};

export default FooterQuery;
